import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/Services/login.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Usuario } from 'src/app/Models/usuario.model';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { UserToken } from 'src/app/Models/token.model';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'ppa-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  formLogin: FormGroup;
  formCadastreSe: FormGroup;
  participante: UserToken;

  @BlockUI() blockUI: NgBlockUI;

  constructor(private rota: Router, private loginService: LoginService,
    private formBuilder: FormBuilder, private toast: ToastrService) { }

  ngOnInit() {
    this.inicializarForm();
    this.blockUI.stop();
  }

  inicializarForm() {
    this.formLogin = this.formBuilder.group({
      cpf: this.formBuilder.control(''),
      senha: this.formBuilder.control('')
    });

    this.formCadastreSe = this.formBuilder.group({});
  }

  login() {
    const model: Usuario = this.formLogin.getRawValue();
    this.blockUI.start('Aguarde...');

    this.loginService.autenticarParticipante(model)
      .pipe(
        finalize(() => this.blockUI.stop())
      ).subscribe((response: UserToken) => {
        this.participante = response;
        this.rota.navigate(['participante']);//.then(() => this.toast.success(`Olá, ${this.participante.usuario_logado}`));
      }, (erro: HttpErrorResponse) => {
        this.toast.error(erro.error.error_description, null, { enableHtml: true });
      });
  }

  cadastrar() {

  }

}
